import { render } from "./LicenceItem.vue?vue&type=template&id=e542fd94&scoped=true"
import script from "./LicenceItem.vue?vue&type=script&lang=js"
export * from "./LicenceItem.vue?vue&type=script&lang=js"

import "./LicenceItem.vue?vue&type=style&index=0&id=e542fd94&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e542fd94"]])

export default __exports__